export const FEATURE_FLAG_KEYS = {
  cardCollectionResponsiveColumns: "EnableCcofResponsiveCardCollectionTable",
} as const;
